import React from 'react';
import { NavLink } from 'react-router-dom';
import { NativeButton, ButtonVariant } from '../components/button';

/**
 * @deprecated This deprecated as a consequence of ToolbarLink being deprecated
 * */
interface MenuItem {
  key?: string;
  path: string;
  exact: boolean;
  icon: React.ReactNode;
  title: string;
  buttonVariant?: ButtonVariant;
}

/**
 * @deprecated This approach is invalid according to HTML5. It is also quarrelsome
 * with regard to the styling of other buttons in the toolbar.
 * Source: https://html.spec.whatwg.org/multipage/text-level-semantics.html#the-a-element
 * Quote: "The a element can be wrapped around entire paragraphs, lists, tables,
 * and so forth, even entire sections, so long as there is no interactive content within
 * (E.G., BUTTONS OR OTHER LINKS)"
 * */
export const ToolbarLink: React.FC<React.PropsWithChildren<MenuItem>> = ({
  key,
  path,
  exact,
  icon,
  title,
  buttonVariant = ButtonVariant.Primary,
}) => {
  return (
    <NavLink
      key={key}
      to={{ pathname: path }}
      end={exact}
      className={({ isActive }) => `menu-item${isActive ? ' active' : ''}`}
    >
      <NativeButton variant={buttonVariant}>
        {icon}
        &nbsp;
        <span>{title}</span>
      </NativeButton>
    </NavLink>
  );
};
